var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-tabs", {
    model: {
      value: _vm.activeKey,
      callback: function ($$v) {
        _vm.activeKey = $$v;
      },
      expression: "activeKey"
    }
  }, [_c("a-tab-pane", {
    key: 1,
    attrs: {
      tab: _vm.$t("功能权限")
    }
  }, [_vm.activeKey == 1 ? _c("authority", {
    attrs: {
      type: "customerRole",
      id: this.$route.params.id
    },
    on: {
      ok: _vm.handleOk
    }
  }) : _vm._e()], 1), _c("a-tab-pane", {
    key: 2,
    attrs: {
      tab: _vm.$t("数据权限")
    }
  }, [_vm.activeKey == 2 ? _c("data-authority") : _vm._e()], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };